import router from './router'

export default {
	moduleName: 'template',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/template/index.js